import { Route } from '@angular/router';
import {ArticleResolver} from "./resolver/article.resolver";
import {ThemeResolver} from "./resolver/theme.resolver";
import {TagResolver} from "./resolver/tag.resolver";


export const appRoutes: Route[] = [
  {
    path: '404',
    loadComponent: () =>
      import('./not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./nx-welcome.component').then(
        (m) => m.NxWelcomeComponent
      ),

  },
  {
    path: 'catalog',
    loadComponent: () =>
      import('./pages/catalog/catalog.component').then(
        (m) => m.CatalogComponent
      ),

  },
  {
    path: 'product/:id',
    loadComponent: () =>
      import('./pages/product/product.component').then(
        (m) => m.ProductComponent
      ),

  },
  {
    path: 'tag/:tag',
    loadComponent: () =>
      import('./pages/tag/tag.component').then(
        (m) => m.TagComponent
      ),
    resolve: {state:TagResolver},
  },
  {
    path: ':slugTheme/:slugArticle',
    loadComponent: () =>
      import('./pages/article/article.component').then(
        (m) => m.ArticleComponent
      ),
    resolve: {article:ArticleResolver},
  },
  {
    path: ':slugTheme',
    loadComponent: () =>
      import('./pages/theme/theme.component').then(
        (m) => m.ThemeComponent
      ),
    resolve: {theme:ThemeResolver},
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  }
];
